import base from "../../baseurl";
import token from "../../getTk";

const Create = async (id) => {
  console.log("Este es el chido");
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  const newS = await api
    .post("disciplines/delete", {
      json: { id },
      timeout: false,
    })
    .json();
  return newS;
};

export default Create;
